import { AbstractDataSource } from './abstract.datasource';
import { ViewService } from '../services/crud/interfaces/view-service.interface';
import { Observable } from 'rxjs';

export class ReadonlyDataSource<T> extends AbstractDataSource<T> {
  constructor(private service: ViewService<T>) {
    super();
  }

  getData(pagingAndSortingData: any): Observable<any> {
    const str = this._filter.str || '';
    const dateFilterCols = this._filter.dateFilterCols || [];
    // const companiesFilter = this._filter.companiesFilter || [];
    const startFilterDate = this._filter.startFilterDate || null;
    const endFilterDate = this._filter.endFilterDate || null;
    const someAdditionalData = this._filter.someAdditionalData || '';

    const additionalFilterData = this._filter.additionalFilterData || [];
    const enumFilter = this._filter.enumFilter || '';
    const companiesFilter = this._filter.companiesFilter || [];

    const additionalField1 = this._filter.additionalField1 || '';
    const additionalField2 = this._filter.additionalField2 || '';
    const additionalValue1 = this._filter.additionalValue1 || '';
    const additionalValue2 = this._filter.additionalValue2 || '';

    const numberTo = this._filter.numberFrom || null;
    const numberFrom = this._filter.numberTo || null;

    const productsFilter = this._filter.productsFilter || [];

    return this.service.getMany(
      pagingAndSortingData.pageIndex,
      pagingAndSortingData.pageSize,
      pagingAndSortingData.sortField,
      pagingAndSortingData.sortDirection,
      str,
      dateFilterCols,
      startFilterDate,
      endFilterDate,
      someAdditionalData,
      productsFilter,

      additionalField1,
      additionalField2,
      additionalValue1,
      additionalValue2,

      numberTo,
      numberFrom,

    );
  }
}
